import { baseUrl, buildQueryParams } from "./Requests.js";

// 네이버 로그인 처리
async function SigninWithNaver(code) {
  const params = buildQueryParams({
    code: code
  });
  return (
    await fetch(`${baseUrl}/signin/naver?${params.toString()}`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
  )
}

// 카카오 로그인 처리
async function SigninWithKakao(code) {
  const params = buildQueryParams({
    code: code
  });
  return (
    await fetch(`${baseUrl}/signin/kakao?${params.toString()}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
  )
}

// 구글 로그인 처리
async function SigninWithGoogle(idToken) {
  const params = buildQueryParams();

  return (
    await fetch(`${baseUrl}/signin/google?${params.toString()}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id_token: idToken }),
      credentials: "include",
    })
  )
}

// 로그아웃 처리
async function Logout() {
  const params = buildQueryParams();
  return (
    await fetch(`${baseUrl}/logout?${params.toString()}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
  )
}

// 회원 탈퇴 처리
async function DeleteAccount(user_id, is_deleted) {
  const params = buildQueryParams({
    user_id: user_id,
    is_deleted: is_deleted
  });
  return (
    await fetch(`${baseUrl}/delete?${params.toString()}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
  )
}

export { SigninWithGoogle, SigninWithNaver, SigninWithKakao, Logout, DeleteAccount };
